import React from "react";

export const ButtonIcon = () => {
    return <svg className="button__icon" viewBox="0 0 6.37 12"><g id="a" /><g id="b"><g id="c"><path className="d" d="M6.23,5.52L.85,.15C.66-.05,.34-.05,.15,.15S-.05,.66,.15,.85L5.29,6,.15,11.15c-.2,.2-.2,.51,0,.71,.1,.1,.23,.15,.35,.15s.26-.05,.35-.15L6.23,6.48c.13-.13,.17-.31,.12-.48,.04-.17,0-.35-.12-.48Z" /></g></g></svg>;
};